var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"loading-background",class:{
    'loading-background--animate': _vm.animateBackground && !_vm.loadedFinal,
    'loading-background--loaded': _vm.loadedFinal,
  }},[_c('div',{staticClass:"loading-background__background"},[_c('div',{staticClass:"loading-background__message"},[_vm._v(" "+_vm._s(_vm.message)+" ")])]),_c('div',{staticClass:"loading-background__content",class:{
      'loading-background--animate': _vm.animateBackground && !_vm.loadedFinal,
      'loading-background--loaded': _vm.loadedFinal,
    }},[_vm._t("default")],2)])}
var staticRenderFns = []

export { render, staticRenderFns }